import { noop } from '../../../../../lib/utilities';
import React from 'react';
import PropTypes from 'prop-types';
import { Row } from '../structure/row';
import { Cell, CENTER } from '../structure/cell';
import Translation from '../../translation/translation';

export function GoToCheckout(props) {
    const buttonTranslationKey = props.hasFitting ?
        'sidebar-go-to-checkout-with-fitting-station-button' :
        'sidebar-go-to-checkout-button';

    return (
        <Row className="go-to-checkout" hasBorder={props.hasBorder}>
            <Cell side={CENTER} colSpan={3} className="go-to-checkout__cell">
                <form
                    action={props.baseUrl + '/checkout/address/'}
                    method="POST"
                >
                    <Translation
                        tagName="button"
                        className={`go-to-checkout__button ${!props.fittingStationAllowed ? 'without-fitting' : ''}`}
                        onClick={props.onGoToCheckoutClick}
                        translationKey={props.label || buttonTranslationKey}
                        placeholder={props.placeholder}
                    />
                </form>
            </Cell>
        </Row>
    );
}

GoToCheckout.propTypes = {
    fittingStationAllowed: PropTypes.bool.isRequired,
    hasFitting: PropTypes.bool.isRequired,
    baseUrl: PropTypes.string.isRequired,
    onGoToCheckoutClick: PropTypes.func,
    hasBorder: PropTypes.bool,
    placeholder: PropTypes.object,
};

GoToCheckout.defaultProps = {
    onGoToCheckoutClick: noop,
    hasBorder: true,
    placeholder: {},
};
